import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
const Hsbc = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  // const currentCards = CreditCardData.cards
  //   ?.filter((card) => card.category === "Credit card")
  //   .slice(indexOfFirstCard, indexOfLastCard);
  // console.log({ currentCards });
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("hsbc"))
    .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const faqs = [
    {
      question: "Which is the best HSBC credit card currently available?",
      answer:
        "The HSBC Cashback Credit Card and HSBC Smart Value Credit Card are top picks, offering cashback on groceries, fuel, and bill payments, along with dining privileges.",
    },
    {
      question: "Does HSBC offer lifetime free credit cards?",
      answer:
        " Yes, some variants like the HSBC Cashback Credit Card come with no joining or annual fee, provided you meet the spending conditions.",
    },
    {
      question: "Are HSBC credit cards good for international use?",
      answer:
        " Yes, with global Visa/Mastercard networks and low forex markup fees (usually around 2.5%), they are well-suited for frequent international travelers.",
    },
    {
      question: "Can I apply for an HSBC credit card from any city?",
      answer:
        "   Currently, HSBC credit cards are only issued in select tier-1 cities. Make sure your residential address falls under their serviceable locations.",
    },
    {
      question: "How long does it take to get an HSBC credit card?",
      answer:
        " The approval process typically takes 5–7 working days, and once approved, the card is delivered within 10–12 days via secure courier.",
    },
  ];

  const steps = [
    {
      icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
      title: "Check Eligibility",
      description:
        " Confirm that your income, employment type, and location align with the eligibility norms specified for each HSBC credit card to avoid application rejections.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
      title: "Keep Documents Handy",
      description:
        " Ensure you have scanned or photocopied versions of your ID, address proof, PAN card, and income documents, as these are mandatory for the verification process.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Apply via Official HSBC Portal",
      description:
        " Once you find a suitable card, click “Apply Now” to be redirected to HSBC’s official credit card application portal where your request will be securely processed.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "Browse through our curated list of HSBC Bank credit cards at TheFinMaster. We break down each card’s benefits, reward structure, eligibility, and ideal user type so you can choose the perfect card for your lifestyle.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Get HSBC Credit Card - Apply Online for Best Credit Cards 2024 at
          TheFinmaster
        </title>
        <meta
          name="description"
          content="HSBC Credit Card - Apply for HSBC Credit Cards Online &amp; Get benefits like Fuel, Airline, PAYBACK, Lifestyle, Reward Points and Cashback available on HSBC Credit Car | TheFinmaster"
        />
        <meta
          name="keywords"
          content="hsbc credit card, hsbc platinum credit card, hsbc cashback credit card, hsbc paying credit card, hsbc bank debit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/hsbc-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>

      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Explore Premium, Rewarding & Globally Accepted HSBC Credit Cards
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              HSBC Bank offers a select portfolio of credit cards tailored for
              discerning users who seek global acceptance, premium travel perks,
              and strong cashback or rewards on every spend. Known for their low
              forex markups and no annual fee on select cards, HSBC credit cards
              are ideal for international travelers, high-spenders, and those
              who value premium banking experiences.
            </p>
          </div>
        </div>

        <h1 className="text-center text-2xl md:text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

            <div className="w-full relative ">
                              <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                                {/* <div className="w-[70%] mx-auto">
                                                           <h2 className="text-center font-medium pt-5 text-lg">
                                                             <span className="font-semibold text-white">816 people</span>{" "}
                                                             are on call with our advisors right now
                                                           </h2>
                                                         </div> */}
                                <div className="w-full mx-auto">
                                  <Link
                                    to="https://play.google.com/store/apps/details?id=com.popclub.android&pcampaignid=web_share"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <div className="w-[80%] mx-auto ">
                                      <img src="/assets/ppp.png" alt="Advertisement" />
                                    </div>
                                  </Link>
                                  <div className="bg-white">
                                    {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                               Know your advisor
                                                             </h3> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

        {/* <div className='w-[95%] py-10'>
                                   <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                                   <AccordionComponent />
                               </div> */}

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for HSBC Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Age Requirement
                  </span>
                  <span>
                    {" "}
                    Applicants must be between 21 and 60 years old. For add-on
                    cards, the minimum age is 18 years.{" "}
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Income
                  </span>
                  <span>
                    {" "}
                    HSBC credit cards typically require a minimum monthly income
                    of ₹40,000 or more, depending on the variant chosen.{" "}
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score
                  </span>
                  <span>
                    {" "}
                    A credit score of 700 or above is generally expected. Strong
                    credit history improves your chances for premium variants.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Employment Type
                  </span>
                  <span>
                    {" "}
                    Both salaried and self-employed individuals are eligible.
                    You must be employed with a reputable organization or have a
                    well-documented business income.{" "}
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Residential Cities
                  </span>
                  <span>
                    {" "}
                    HSBC credit cards are currently issued in select major
                    cities like Mumbai, Delhi, Bengaluru, Pune, Hyderabad,
                    Chennai, and Kolkata. Ensure your city is serviceable before
                    applying.{" "}
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for HSBC Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    {" "}
                    Valid government-issued ID such as PAN Card, Aadhaar Card,
                    Passport, or Driving License is mandatory for KYC purposes.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Address
                  </span>
                  <span>
                    {" "}
                    Submit a recent utility bill, Aadhaar, bank statement, or
                    passport as acceptable proof of residence.{" "}
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Income
                  </span>
                  <span>
                    {" "}
                    Salaried: Latest 3 months’ salary slips and 6-month bank
                    statement showing credited salary. Self-employed: Latest
                    ITR, business ownership proof, and bank statements are
                    required.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Passport-size Photograph
                  </span>
                  <span>
                    {" "}
                    One or two recent color passport-size photographs must be
                    submitted with the application form.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Permanent Account Number (PAN)
                  </span>
                  <span>
                    {" "}
                    PAN is mandatory as per RBI guidelines for financial
                    validation and credit underwriting.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for HSBC Bank Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
                             Applying for a fuel credit card is a seamless process that starts with
                             the right research and ends at the official bank’s platform for final
                             submission. Here’s how you can get started through TheFinMaster.com:
                           </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Hsbc;
